import React, { useContext } from 'react'
import classNames from 'classnames'
import OnboardSubTitle from './OnboardSubTitle'
import OnboardTitle from './OnboardTitle'
import { InviteDetailsContext } from '../../utils/contexts'
import { conditionMatched } from '../layout/Layout'

const signupTitle = 'Your Journey Begins with Awareness'
const signupSubTitle =
  'Join thousands of leaders and their teams who have taken our awareness assessment to uncover hidden opportunities for growth.'
const questEntrySubTitle = `Thank you for joining this life-changing journey, where you'll
                connect with yourself, others, and the wisdom of Bhutan
                alongside a curated group of leaders. Please create your
                account, process your payment, and complete enrollment to
                confirm your place and begin preparing for this extraordinary
                experience.`
const SignupLeftSection = ({ isQuestEntry = false }) => {
  const { inviteLinkDetails } = useContext(InviteDetailsContext)

  return (
    <section
      className={classNames({
        'h-lg-65': !conditionMatched,
      })}>
      <div
        className={classNames(
          'd-flex flex-column align-items-start text-start',
          {
            'signup-left-section': !inviteLinkDetails?.header,
            'signup-invite-link': inviteLinkDetails?.header,
            'me-lg-5 ms-lg-0 mx-sm-5 mx-md-5 mb-5 px-3 ps-md-0 ps-lg-0':
              isQuestEntry,
          },
        )}>
        <OnboardTitle className='word-break'>
          {isQuestEntry
            ? inviteLinkDetails?.header ||
              'Welcome to True Prosperity in Bhutan'
            : inviteLinkDetails?.header
            ? inviteLinkDetails?.header
            : signupTitle}
        </OnboardTitle>
        {inviteLinkDetails?.body ? (
          <OnboardSubTitle
            className='word-break opacity-75 mt-4 w-100'
            commonClass='s5'>
            <div
              dangerouslySetInnerHTML={{
                __html: `<div>${inviteLinkDetails?.body}</div>`,
              }}
            />
          </OnboardSubTitle>
        ) : (
          <OnboardSubTitle
            className='word-break opacity-75 mt-4'
            commonClass='s5'>
            {isQuestEntry ? questEntrySubTitle : signupSubTitle}
          </OnboardSubTitle>
        )}
      </div>
    </section>
  )
}

export default SignupLeftSection
